<template>
    <div>

        <trax-ui-card v-if="learnerValidationRequired">
            <h3 class="text-center font-weight-bold">{{ lang.polaris.dashboard.action_required }}</h3>
            <p class="text-center">{{ lang.polaris.dashboard.learner_sign_text }}</p>
            <div class="mt-3 mb-3 text-center">
                <button class="btn btn-lg btn-round btn-danger" @click="sign('learner_validation')">
                    {{ lang.polaris.dashboard.sign }}
                </button> 
            </div>
        </trax-ui-card>

        <trax-ui-card v-if="thirdValidationRequired">
            <h3 class="text-center font-weight-bold">{{ lang.polaris.dashboard.action_required }}</h3>
            <p class="text-center">{{ lang.polaris.dashboard.third_sign_text }}</p>
            <div class="mt-3 mb-3 text-center">
                <button class="btn btn-lg btn-round btn-danger" @click="sign('third_validation')">
                    {{ lang.polaris.dashboard.sign }}
                </button> 
            </div>
        </trax-ui-card>

        <trax-ui-card :title="lang.polaris.dashboard.status" v-if="!actionRequired && validated">

            <!-- States -->
            <trax-ui-simple-table header="0" :rows="rows" :cols="cols" vertical-align="top">
            </trax-ui-simple-table>

            <!-- Actions -->
            <div class="mt-3 mb-3 text-center" v-if="additionalSignatoryPermission || editDashboardPermission || unlockPermission">

                <!-- Additional signatory -->
                <button class="btn btn-round btn-danger" @click="sign('third_validation')"  v-if="additionalSignatoryPermission">
                    {{ lang.polaris.dashboard.sign }}
                </button> 
                
                <!-- Unlock -->
                <button class="btn btn-round btn-default" data-toggle="modal" data-target="#enac-atpl-dashboard-unlock-sheet" v-if="unlockPermission">
                    {{ lang.polaris.dashboard.unlock_sheet }}
                </button> 

                <!-- Unlock request -->
                <button class="btn btn-round btn-default" data-toggle="modal" data-target="#enac-atpl-dashboard-ask-to-unlock-sheet" v-if="!unlockPermission && editDashboardPermission">
                    {{ lang.polaris.dashboard.unlock_sheet_request }}
                </button> 

            </div>
        </trax-ui-card>

        <!-- Signature modal -->

        <trax-ui-modal-default id="enac-atpl-dashboard-sign" :bus="bus" :title="lang.polaris.dashboard.signature">
            <enac-atpl-dashboard-item-save-sign-popup id="enac-atpl-dashboard-sign" :bus="bus" simple-text="1"></enac-atpl-dashboard-item-save-sign-popup>
        </trax-ui-modal-default>

        <!-- Unlock sheet confirm modal -->

        <trax-ui-modal-confirm id="enac-atpl-dashboard-unlock-sheet" :title="this.lang.polaris.dashboard.unlock_sheet" :bus="bus">
            {{ lang.polaris.dashboard.confirm_unlock_sheet_q }}
        </trax-ui-modal-confirm>

        <!-- Ask to unlock sheet confirm modal -->

        <trax-ui-modal-confirm id="enac-atpl-dashboard-ask-to-unlock-sheet" :title="this.lang.polaris.dashboard.unlock_sheet_request" :bus="bus">
            {{ lang.polaris.dashboard.confirm_unlock_sheet_request_q }}
        </trax-ui-modal-confirm>

        <!-- Toastr -->

        <trax-ui-toastr id="enac-atpl-dashboard-toastr" passed-label="1" :bus="bus">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {

        props: {
            additionalSignatory: {default: false},
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                state: data.state,
                registration: data.registration,
                learner: data.learner,
                endpointBase: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/learning-units/'+data.item.id,
                rows: [],
                cols: [
                    {class: 'text-center'},
                    {class: 'text-center'},
                    {},
                ],
                signProp: null,
                bus: this.$bus
            }
        },

        created: function() {
            this.populateTable();  
            this.bus.$on('enac-atpl-dashboard-unlock-sheet-confirmed', this.unlock);
            this.bus.$on('enac-atpl-dashboard-ask-to-unlock-sheet-confirmed', this.unlockRequest);
            this.bus.$on('enac-atpl-dashboard-sign-created', this.signed);
        },

        computed: {

            // An archived registration is closed: its sheets are read-only, so none of the
            // signature, unlock or unlock request actions is offered anymore.
            editableStatus: function() {
                return this.registration.status != 'archived';
            },

            unlockPermission: function() {
                return this.editableStatus
                    && (this.user.admin || this.user.permissions['dashboard.unlock']);
            },

            editDashboardPermission: function() {
                return this.editableStatus
                    && (this.user.admin || this.user.permissions['dashboard.write-all'] || this.user.permissions['dashboard.write-mine-locations']);
            },

            // Nobody countersigns their own sheet: an occasional learner holds a training
            // center function, but the sheet is about their own training.
            notMyOwnSheet: function() {
                return this.learner.id != this.user.id;
            },

            additionalSignatoryPermission: function() {
                return this.editableStatus && this.additionalSignatory && !this.thirdPartyValidated && this.notMyOwnSheet
                    && (this.user.user_function == 'training' || this.user.user_function == 'training_op');
            },

            actionRequired: function () {
                return this.learnerValidationRequired || this.thirdValidationRequired;
            },

            learnerValidationRequired: function() {
                return this.editableStatus && this.validated && !this.learnerValidated && this.learner.id == this.user.id;
            },

            thirdValidationRequired: function() {
                return this.editableStatus && this.validated && this.thirdPartyWaited && !this.thirdPartyValidated
                    && this.notMyOwnSheet && this.state.additional_signatory.user_uuid == this.user.uuid;
            },

            validated: function () {
                return this.state && this.state.validation;
            },

            learnerValidated: function () {
                return this.state && this.state.learner_validation;
            },

            thirdPartyValidated: function () {
                return this.state && this.state.third_validation;
            },

            thirdPartyWaited: function () {
                return this.state && this.state.additional_signatory && this.state.additional_signatory.user_uuid;
            },

            endpoint: function() {
                return this.endpointBase+'/learners/'+this.learner.id+'/sign';
            }
        },

        methods: {

            populateTable() {
                this.rows = [];

                // Initial validation
                if (!this.validated) return;
                this.rows.push([
                    this.dateHtml(this.state.validation),
                    this.statusHtml(lang.polaris.dashboard.signed, 'success'),
                    this.userHtml(this.state.validation),
                ]);

                // Learner validation
                if (this.learnerValidated) {

                    this.rows.push([
                        this.dateHtml(this.state.learner_validation),
                        this.statusHtml(lang.polaris.dashboard.signed, 'success'),
                        this.userHtml(this.state.learner_validation),
                    ]);
                } else {

                    this.rows.push([
                        '',
                        this.statusHtml(lang.polaris.dashboard.waiting, 'danger'),
                        this.userHtml(this.learner),
                    ]);
                }

                // Third validation
                if (this.thirdPartyValidated) {

                    this.rows.push([
                        this.dateHtml(this.state.third_validation),
                        this.statusHtml(lang.polaris.dashboard.signed, 'success'),
                        this.userHtml(this.state.third_validation),
                    ]);

                } else if (this.thirdPartyWaited) {

                    this.rows.push([
                        '',
                        this.statusHtml(lang.polaris.dashboard.waiting, 'danger'),
                        this.userHtml(this.state.additional_signatory),
                    ]);

                } else if (this.additionalSignatory) {

                    this.rows.push([
                        '',
                        this.statusHtml(lang.polaris.dashboard.waiting, 'danger'),
                        this.userAltHtml(lang.polaris.dashboard.additional_signatory),
                    ]);
                }
            },

            statusHtml(label, color) {
                var html = '';
                html += '<span class="badge badge-'+color+'">'+label+'</span>';
                return html;
            },

            dateHtml(user) {
                var html = '';
                if (user) html += '<small>' + moment(user.date).format('DD MMM YYYY') + '</small>';
                return html;
            },

            userHtml(user) {
                var userName = user.user_name ? user.user_name : user.lastname + ' ' + user.firstname;
                var html = '';
                html += '<span class="font-weight-bold">' + userName + '</span>';
                return html;
            },

            userAltHtml(userLabel) {
                var html = '';
                html += '<span class="font-weight-bold">' + userLabel + '</span>';
                return html;
            },

            sign(signProp) {
                this.signProp = signProp;
                this.bus.$emit('enac-atpl-dashboard-sign-create');
            },

            signed() {
                this.postData({sign: this.signProp}, function(data) {
                    this.state = data.summary.data;
                    this.populateTable();
                });
            },

            unlock() {
                this.postData({unlock: true}, function(data) {
                    window.location = './'+this.learner.id+'/edit';
                });
            },

            unlockRequest() {
                var that = this;
                this.postData({ask_to_unlock: true}, function(data) {
                    that.bus.$emit('enac-atpl-dashboard-toastr-success', that.lang.polaris.dashboard.unlock_request_sent);
                });
            },

            postData(data, callback) {
                var that = this;
                axios.post(this.endpoint, data)
                    .then(function (response) {
                        callback.call(that, response.data.data);
                    })
                    .catch(function (error) {
                    });
            }
        }

    }
</script>
